import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { useProductApiSwrFetchCartMetadata } from '../../../../../product'

/**
 * if private prescription,
 * load metadata,
 * if metadata has erx and private prescription, add to cart cta shall be disabled,
 * and some info message shall be shown
 */
export const useIsPrivatePrescriptionAndCartMetadataHasErx = (
  prescription: PrescriptionPrescriptionTypeEnum,
): boolean => {
  const isPrivatePrescription =
    prescription === PrescriptionPrescriptionTypeEnum.PrivatePrescription

  const metadata = useProductApiSwrFetchCartMetadata({
    disabled: !isPrivatePrescription,
  })

  return isPrivatePrescription && Boolean(metadata.data?.hasERxItems)
}
